import { detectInviteType } from "@ano/shared/api/invites";
import { parseAppPath } from "@/lib/app-route";
import type { AuthIntentSurface } from "@/lib/analytics-events";

/**
 * Derive the auth-intent context from the current URL at click time, so the
 * `auth intent` event carries which surface the visitor came from (and any
 * community slug) BEFORE the OAuth redirect drops that context. Extracted from
 * AuthGate so it stays unit-testable and keeps AuthGate under the LOC ceiling.
 */
export function deriveAuthIntentContext(): {
  surface: AuthIntentSurface;
  slug?: string;
  inviteTokenPresent: boolean;
} {
  const params = new URLSearchParams(window.location.search);
  const token = params.get("invite") ?? params.get("space_invite");
  const inviteTokenPresent = !!token;
  const inviteType = token ? detectInviteType(token) : null;
  const slug = parseAppPath().workspaceSlug ?? undefined;
  const surface: AuthIntentSurface =
    inviteType === "dm" || inviteType === "group_dm"
      ? "guest_mode"
      : inviteTokenPresent
        ? "invite_page"
        : slug
          ? "public_landing"
          : "sign_in_wall";
  return { surface, slug, inviteTokenPresent };
}
